import axios from "axios";
//import { push } from "connected-react-router";
import setAuthToken from "../utils/setAuthToken";
import { API_URI } from "../utils/config";
//import jwt_decode from "jwt-decode";

import {
  GET_ERRORS,
  SET_CURRENT_USER,
  GET_USERS,
  GET_ADMIN_USERS,
  CLEAR_CURRENT_USER,
  GET_STATS
} from "./types";

// Register User
/* export const registerUser = (userData, history) => dispatch => {
  axios
    .post("/api/users/register", userData)
    .then(res => history.push("/login"))
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    );
}; */

// Login - Get User Token
export const loginUser = (userData, history) => dispatch => {
  axios
    .post(`${API_URI}/users/login`, userData)
    .then(res => {
      if (res.data.error.code) {
        dispatch({
          type: GET_ERRORS,
          payload: res.data.error.message
        });
      } else {
        // Save to localStorage
        const { token, data } = res.data;
        // Set token to ls
        localStorage.setItem("jwtToken", token);
        // Set token to Auth header
        setAuthToken(token);
        // Set current user
        dispatch(setCurrentUser(data));
        history.push("/dashboard");
      }
    })
    .catch(err => {
      if (err.response.data.error) {
        dispatch({
          type: GET_ERRORS,
          payload: err.response.data.error.message
        });
      }
    });
};

//  Get User User
export const currentUser = () => dispatch => {
  axios
    .get(`${API_URI}/me/users`)
    .then(res => {
      if (res.data.error.code) {
        dispatch({
          type: GET_ERRORS,
          payload: res.data.error
        });
      } else {
        // Save to localStorage
        const { data } = res.data;
        // Set current user
        dispatch(setCurrentUser(data));
      }
    })
    .catch(err => {
      dispatch({
        type: GET_ERRORS,
        payload: err
      });
    });
};

export const clearCurrentProfile = () => dispatch => {
  return {
    type: CLEAR_CURRENT_USER,
    payload: {}
  };
};

// Set logged in user
export const setCurrentUser = user => {
  return {
    type: SET_CURRENT_USER,
    payload: user
  };
};

// Log user out
export const logoutUser = () => dispatch => {
  axios
    .get(`${API_URI}/me/users`)
    .then(res => {
      if (res.data.error.code) {
        dispatch({
          type: GET_ERRORS,
          payload: res.data.error
        });
      } else {
        // Remove token from localStorage
        localStorage.removeItem("jwtToken");
        // Remove auth header for future requests
        setAuthToken(false);
        // Set current user
        dispatch(clearCurrentProfile());
        //history.push("/login");

        window.location.href = `${window.location.origin.toString()}/`;
        //window.location.href = "http://aqar.tecnovaters.com/";
      }
    })
    .catch(err => {
      dispatch({
        type: GET_ERRORS,
        payload: err
      });
    });
};

// Get all Users
export const getAllUser = () => dispatch => {
  axios
    .get(
      `${API_URI}/users?filter={"include":{"0": "attachment"},"where": {"role_id": 2, "is_deleted": 0},"skip": "0","limit":"all"}`
    )
    .then(res => {
      if (res.data.error.code) {
        dispatch({
          type: GET_ERRORS,
          payload: res.data.error
        });
      } else {
        const { data } = res.data;
        dispatch({
          type: GET_USERS,
          payload: data
        });
      }
    })
    .catch(err => {
      dispatch({
        type: GET_ERRORS,
        payload: err
      });
    });
};

// Get all Admins
export const getAllAdmin = () => dispatch => {
  axios
    .get(
      `${API_URI}/users?filter={"include":{"0": "attachment"},"where": {"role_id": 1, "is_deleted": 0},"skip": "0","limit":"all"}`
    )
    .then(res => {
      if (res.data.error.code) {
        dispatch({
          type: GET_ERRORS,
          payload: res.data.error
        });
      } else {
        const { data } = res.data;
        dispatch({
          type: GET_ADMIN_USERS,
          payload: data
        });
      }
    })
    .catch(err => {
      dispatch({
        type: GET_ERRORS,
        payload: err
      });
    });
};

export const getStats = () => dispatch => {
  axios
    .get(`${API_URI}/stats`)
    .then(res => {
      if (res.data.error.code) {
        dispatch({
          type: GET_ERRORS,
          payload: res.data.error
        });
      } else {
        const { data } = res;
        dispatch({
          type: GET_STATS,
          payload: data
        });
      }
    })
    .catch(err => {
      dispatch({
        type: GET_ERRORS,
        payload: err
      });
    });
};

// Update User
export const updateUser = (userData, id) => (dispatch, getState) => {
  let users = [...getState().auth.users];
  axios
    .put(`${API_URI}/users/${id}`, userData)
    .then(res => {
      if (res.data.error.code) {
        dispatch({
          type: GET_ERRORS,
          payload: res.data.error.message
        });
      } else {
        const { data } = res.data;
        users = users.map(user => {
          if (user.id === data.id) {
            user = { ...user, ...data };
          }
          return user;
        });
        dispatch({
          type: GET_USERS,
          payload: users
        });
      }
    })
    .catch(err => {
      if (err.response.data.error) {
        dispatch({
          type: GET_ERRORS,
          payload: err.response.data.error.message
        });
      }
    });
};

// Update Admin
export const updateAdmin = (userData, id) => (dispatch, getState) => {
  let admins = [...getState().auth.admins];

  axios
    .put(`${API_URI}/users/${id}`, userData)
    .then(res => {
      if (res.data.error.code) {
        dispatch({
          type: GET_ERRORS,
          payload: res.data.error
        });
      } else {
        const { data } = res.data;
        admins = admins.map(user => {
          if (user.id === data.id) {
            user = { ...user, ...data };
          }
          return user;
        });
        dispatch({
          type: GET_ADMIN_USERS,
          payload: admins
        });
      }
    })
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    );
};

// Delete User
export const deleteUser = id => (dispatch, getState) => {
  let users = [...getState().auth.users];

  axios
    .delete(`${API_URI}/users/${id}`)
    .then(res => {
      if (res.data.error.code) {
        dispatch({
          type: GET_ERRORS,
          payload: res.data.error
        });
      } else {
        users = users.filter(user => user.id !== id);
        dispatch({
          type: GET_USERS,
          payload: users
        });
      }
    })
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    );
};

// Delete Admin
export const deleteAdmin = id => (dispatch, getState) => {
  let admins = [...getState().auth.admins];

  axios
    .delete(`${API_URI}/users/${id}`)
    .then(res => {
      if (res.data.error.code) {
        dispatch({
          type: GET_ERRORS,
          payload: res.data.error
        });
      } else {
        admins = admins.filter(user => user.id !== id);
        dispatch({
          type: GET_ADMIN_USERS,
          payload: admins
        });
      }
    })
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    );
};

// Add Admin
export const addAdmin = userData => (dispatch, getState) => {
  let admins = [...getState().auth.admins];
  axios
    .post(`${API_URI}/users`, userData)
    .then(res => {
      if (res.data.error.code) {
        dispatch({
          type: GET_ERRORS,
          payload: res.data.error
        });
      } else {
        const { data } = res.data;
        admins.push(data);
        dispatch({
          type: GET_ADMIN_USERS,
          payload: admins
        });
      }
    })
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    );
};

// Update Admin
export const changePassword = (userData, id) => (dispatch, getState) => {
  axios
    .put(`${API_URI}/users/${id}/change_password`, userData)
    .then(res => {
      if (res.data.error.code) {
        dispatch({
          type: GET_ERRORS,
          payload: res.data.error.message
        });
      } else {
        // Remove token from localStorage
        localStorage.removeItem("jwtToken");
        // Remove auth header for future requests
        setAuthToken(false);
        // Set current user
        dispatch(clearCurrentProfile());
        window.location.href = "/login";
      }
    })
    .catch(err => {
      if (err.response.data.error) {
        dispatch({
          type: GET_ERRORS,
          payload: err.response.data.error.message
        });
      }
    });
};

// Forgot Password
export const forgotPassword = userData => (dispatch, getState) => {
  axios
    .post(`${API_URI}/users/forgot_password`, userData)
    .then(res => {
      if (res.data.error.code) {
        dispatch({
          type: GET_ERRORS,
          payload: res.data.error
        });
      } else {
      }
    })
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    );
};



// WEBPACK FOOTER //
// ./src/actions/authActions.js